module.exports = __webpack_public_path__ + "static/media/loader.d5a7df89.svg";